import { Card, MemoryCircles, type MemoryCirclesGroup } from '@wundo/ui';
import { teamMemorySentence } from './teamMemorySentence.ts';
import type { OneOnOneColleagueItem } from '@/lib/colleagues.ts';
import { m } from '@/paraglide/messages.js';

export interface TeamSummaryProps {
  colleagues: readonly OneOnOneColleagueItem[];
  /** A stack was pressed: open the list on that half. */
  onPickGroup: (group: MemoryCirclesGroup) => void;
}

/**
 * The picture over the list: one circle per colleague the user has 1:1s with,
 * drawn in full where Wundo has a memory, and a sentence that counts those.
 * The "Sinds je start" recap says the same sentences.
 */
export function TeamSummary({ colleagues, onPickGroup }: TeamSummaryProps) {
  const count = colleagues.length;
  const memory = colleagues.filter((colleague) => colleague.memory).length;

  return (
    <Card className='px-7 py-6.5 max-mobile:px-5.5 max-mobile:py-5'>
      <MemoryCircles
        people={colleagues.map((colleague) => ({
          id: colleague.id,
          name: colleague.label,
          seed: colleague.email,
          src: colleague.profile_image_url,
          memory: colleague.memory,
        }))}
        label={m.team_circles_label({ memory, count })}
        groupLabels={{ memory: m.team_stack_memory(), without: m.team_stack_without() }}
        onPickGroup={onPickGroup}
      />
      <p className='mt-5 text-xl leading-snug font-medium text-ink max-mobile:text-lg'>
        <span className='block'>
          {count === 1 ? m.team_summary_count_one() : m.team_summary_count({ count })}
        </span>
        <span className='block'>{teamMemorySentence(colleagues)}</span>
      </p>
    </Card>
  );
}
